import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { CredentialsService } from 'src/app/authentication/credentials.service';

@Component({
  selector: 'app-code-enforcement-signin-form',
  templateUrl: './code-enforcement-signin-form.component.html',
  styleUrls: ['./code-enforcement-signin-form.component.scss']
})
export class CodeEnforcementSigninFormComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private activeRouter: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private _snackBar: MatSnackBar,
    private credentialService: CredentialsService,
    public dialog: MatDialog,
  ) { 
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    }

  }
  signInForm: FormGroup;
  @ViewChild('passwordField') passwordField: ElementRef;
  showPassword = false;
  changeCount = 0;
  public showSpinner: boolean = false;
  ngOnInit(): void {
    this.signInForm = this.formBuilder.group({
      userName: ['', Validators.required],
      password: ['', Validators.required],
    });
  }
  onSubmit() {
    this.showSpinner = true;
    if (this.signInForm.value.email == '' || this.signInForm.value.password == '') {
      this._snackBar.open('Error :' + 'Please Enter the right credentials', '', {
        duration: 3000,
        verticalPosition: 'bottom',
        horizontalPosition: 'right',
        panelClass: 'error-snackbar'
      });
      this.showSpinner = false;
      return true;
    }
    this.authenticationService.signIn(this.signInForm.value).subscribe((credentials) => {
      let user = credentials.user;
      if (user.userRoles == null && user.sessionToken && user.auth == 'true') {
        this._snackBar.open('Error :' + 'This user is not associated to any role, please contact support', '', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'right',
          panelClass: 'error-snackbar'
        });
        this.showSpinner = false;
        return;
      }
      // if (user.userRoles[0]. && user.sessionToken && user.auth == 'true') {
      //   this._snackBar.open('Error :' + 'This user is not associated to any role, please contact support', '', {
      //     duration: 3000,
      //     horizontalPosition: 'right',
      //     panelClass: 'error-snackbar'
      //   });
      //   return;
      // }
      if (user.sessionToken && user.auth == 'true') {
        this.credentialService.setCredentials(credentials.user).then((sucess) => {
          console.log(sucess);
          // this.router.navigate(['/vehicle-search']);
          this.router.navigate([this.authenticationService.getCodeEnforcementHomeUrl()], { replaceUrl: true });
        }).catch((err) => console.log(err));
      }
    }, error => {
      const errorMessage = (error && error.error && error.message) ? error.error.message : error.statusText;
      this._snackBar.open('Error :' + errorMessage, '', {
        duration: 3000,
        verticalPosition: 'bottom',
        horizontalPosition: 'right',
        panelClass: 'error-snackbar'
      });
          this.showSpinner = false;
    });
  }
  reset() {
    this.signInForm.reset();
    // this.showPassword = false;
    // this.passwordField.nativeElement.setAttribute('type', 'password');
  }

  forgotPassword() {
    this.router.navigate(['/forgot-pwd'])
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
    if (this.showPassword) {
      this.passwordField.nativeElement.setAttribute('type', 'text');
    } else {
      this.passwordField.nativeElement.setAttribute('type', 'password');
    }
  }
}
